import React from "react";
import styled, { css } from "styled-components";
import colors from "../../styles/colors";

/* https://codepen.io/ben_jammin/pen/syaCq */
const Button = styled.button`
  display: inline-block;
  *display: inline;
  zoom: 1;
  padding: 0.5rem 1rem;
  margin: 0 1rem;
  cursor: pointer;
  border: 1px solid #bbb;
  overflow: visible;
  font-size: 0.75rem;
  font-weight: normal;
  text-decoration: none;
  white-space: nowrap;
  outline: none;
  color: #555;
  background-color: #ddd;
  background-image: linear-gradient(
    top,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0)
  );
  transition: background-color 0.2s ease-out;
  background-clip: padding-box; /* Fix bleeding */
  border-radius: 3px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.3), 0 2px 2px -1px rgba(0, 0, 0, 0.5),
    0 1px 0 rgba(255, 255, 255, 0.3) inset;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.9);
  user-select: none;

  &:hover {
    background-color: #eee;
    color: #555;
  }

  &:active {
    background: #e9e9e9;
    position: relative;
    top: 1px;
    text-shadow: none;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.3) inset;
  }
`;

const CloseButton = styled(Button)`

margin:  0 0.4rem
font-size: 0.75rem;
  background-color: #ca3535;
  color:white
  border-color: #c43c35;

  &:hover {
    background-color:#ca3535cf;
    color:white
  }

  &:active {
    background: #c43c35;
  }
`;
const SaveButton = styled(Button)`
margin: 0 0.4rem
background-color: #269ce9;
color:white
  border-color: #269ce9;

  &:hover {
    background-color: #269ce9d4;
    color:white
  }

  &:active {
    background: #269ce9;
  }
`;

const DisableCommentButton = styled(Button)`
margin: 0 0.4rem
border-color: #eaeaea;
  background: #fafafa;
  cursor: default;
  position: static;
  color: #999;
  box-shadow: none !important;
  text-shadow: none !important;

  &:hover {
    border-color: #eaeaea;
    background: #fafafa;
    cursor: default;
    position: static;
    color: #999;
    box-shadow: none !important;
    text-shadow: none !important;
  }

  &:active {
    border-color: #eaeaea;
    background: #fafafa;
    cursor: default;
    position: static;
    color: #999;
    box-shadow: none !important;
    text-shadow: none !important;
  }
`;

const SmallButton = styled(Button)`
  padding: 4px 12px;
`;

const LargeButton = styled(Button)`
  padding: 12px 30px;
  text-transform: uppercase;

  &:active {
    top: 2px;
  }
`;

const DisabledButton = styled(Button)`
  border-color: #eaeaea;
  background: #fafafa;
  cursor: default;
  position: static;
  color: #999;
  box-shadow: none !important;
  text-shadow: none !important;

  &:hover {
    border-color: #eaeaea;
    background: #fafafa;
    cursor: default;
    position: static;
    color: #999;
    box-shadow: none !important;
    text-shadow: none !important;
  }

  &:active {
    border-color: #eaeaea;
    background: #fafafa;
    cursor: default;
    position: static;
    color: #999;
    box-shadow: none !important;
    text-shadow: none !important;
  }
`;

const ColoredButton = styled(Button)`
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(
    top,
    rgba(255, 255, 255, 0.3),
    rgba(255, 255, 255, 0)
  );

  &:hover {
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(
      top,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0)
    );
  }

  &:active {
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(
      top,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0)
    );
  }
`;

const ColoredSmallButton = styled(SmallButton)`
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(
    top,
    rgba(255, 255, 255, 0.3),
    rgba(255, 255, 255, 0)
  );

  &:hover {
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(
      top,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0)
    );
  }

  &:active {
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(
      top,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0)
    );
  }
`;

const ColoredLargeButton = styled(LargeButton)`
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(
    top,
    rgba(255, 255, 255, 0.3),
    rgba(255, 255, 255, 0)
  );

  &:hover {
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(
      top,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0)
    );
  }

  &:active {
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(
      top,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0)
    );
  }
`;

const RedButton = styled(ColoredButton)`
  background-color: #ca3535;
  border-color: #c43c35;

  &:hover {
    background-color: #ee5f5b;
  }

  &:active {
    background: #c43c35;
  }
`;

const GreenButton = styled(ColoredButton)`
  background-color: ${colors.first};
  border-color: ${colors.first};

  &:hover {
    background-color: #62c462;
  }

  &:active {
    background: ${colors.first};
  }
`;

const BlueButton = styled(ColoredButton)`
  background-color: #269ce9;
  border-color: #269ce9;

  &:hover {
    background-color: #70b9e8;
  }

  &:active {
    background: #269ce9;
  }
`;

const RedLargeButton = styled(ColoredLargeButton)`
  background-color: #ca3535;
  border-color: #c43c35;

  &:hover {
    background-color: #ee5f5b;
  }

  &:active {
    background: #c43c35;
  }
`;

const GreenLargeButton = styled(ColoredLargeButton)`
  background-color: ${colors.first};
  border-color: ${colors.first};

  &:hover {
    background-color: #62c462;
  }

  &:active {
    background: ${colors.first};
  }
`;

const LogoutButton = styled(Button)`
  background-color: ${colors.gray};
  border-color: ${colors.gray};
  color:${colors.bright}
  &:hover {
    background-color: ${colors.middle};
    color:${colors.bright}
  }

  &:active {
    background: ${colors.first};
  }
`;
const SortingButton = styled(Button)`
  background-color: ${colors.gray};
  border-color: ${colors.gray};
  color:${colors.bright}
  &:hover {
    background-color: ${colors.middle};
    color:${colors.bright}
  }

  &:active {
    background: ${colors.first};
  }
`;

export {
  Button,
  SmallButton,
  LargeButton,
  DisabledButton,
  ColoredButton,
  ColoredSmallButton,
  ColoredLargeButton,
  RedButton,
  GreenButton,
  BlueButton,
  RedLargeButton,
  GreenLargeButton,
  CloseButton,
  SaveButton,
  DisableCommentButton,
  LogoutButton,
  SortingButton,
};



// WEBPACK FOOTER //
// ./src/Components/Button/index.js